import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';
import { MlmOrderContext } from '../../model/MlmOrder';
import { MlmFlyerQuantity, MlmFlyerShipping } from '~/tenants/mlm/performable/flyer/MlmFlyerConfig';
import { MLM_FLYER_SHIPPING_RUSH, MLM_FLYER_SHIPPING_STANDARD } from '~/tenants/mlm/performable/flyer/MlmFlyerJob';
import { MlmBrochureShipping } from '~/tenants/mlm/performable/brochures/MlmBrochuresConfig';

export default function MlmFlyerForm(_props: TenantPerformableFormProps<MlmOrderContext>) {
  const [_quantityName, quantity] = useZodFormFieldSingle<MlmFlyerQuantity>('quantity');

  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="quantity" label="Quantity">
        <ZodFieldSelect
          name="quantity"
          options={Object.values(MlmFlyerQuantity).map((id) => ({
            value: id,
            label: id,
          }))}
        />
      </FormHorizontal>

      {quantity && (
        <FormHorizontal name="shipping" label="Shipping">
          <ZodFieldSelect
            name="shipping"
            options={[
              // {
              //   label: 'Pickup',
              //   value: MlmBrochureShipping.PICKUP,
              // },
              {
                label: `Standard ( + $${MLM_FLYER_SHIPPING_STANDARD})`,
                value: MlmFlyerShipping.STANDARD,
              },
              {
                label: `Rush ( + $${MLM_FLYER_SHIPPING_RUSH})`,
                value: MlmFlyerShipping.RUSH,
              },
            ]}
          />
        </FormHorizontal>
      )}
    </TenantPerformableConfiguration>
  );
}
